import { Inject, Injectable, InjectionToken } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { timeout } from "rxjs/operators";

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let timeoutValueNumeric = Number(20000);
    if (req.url.includes('/api/v1/admin/device/command')) {
      timeoutValueNumeric = 40000;
    }
    return next.handle(req).pipe(timeout(timeoutValueNumeric));
  }
}
